export default "__VITE_ASSET__BTl5NKF1__"